import { MmcPlainDataSource } from '../index';
import { configs } from '../configs';
import { memoizeWithAllArgsHashed as memoize } from '../utils';

const entityFactory = {
  publisher: memoize(customerId =>
    new MmcPlainDataSource({
      routePrefix: configs.routes.plainRoute,
      endpoint: configs.endpoints.publishers(customerId),
      entityName: '',
    })),
  deletePublishers: memoize(customerId =>
    new MmcPlainDataSource({
      routePrefix: configs.routes.plainRoute,
      endpoint: configs.endpoints.publishers(customerId),
      entityName: 'DeletePublishers',
    })),
  matchedPublisher: memoize((customerId, searchType) =>
    new MmcPlainDataSource({
      routePrefix: configs.routes.plainRoute,
      endpoint: configs.endpoints.publishers(customerId),
      entityName: `Search${searchType}`,
    })),
  matchedApp: memoize((customerId, publiserId) =>
    new MmcPlainDataSource({
      routePrefix: configs.routes.plainRoute,
      endpoint: configs.endpoints.publishers(customerId),
      entityName: `MatchedApps/${publiserId}`,
    })),
};

export const publisherQueries = {
  getPublishers(customerId, page, pageSize, orderBy) {
    const entity = entityFactory.publisher(customerId);
    const params = {
      Page: page,
      PageSize: pageSize,
      OrderBy: orderBy,
    };

    if (orderBy == null) {
      delete params.OrderBy;
    }
    return entity.get(params);
  },
  createPublisher(customerId, publisherId) {
    const entity = entityFactory.publisher(customerId);
    return entity.post({ SellerId: publisherId });
  },
  deletePublishers(customerId, publisherIds) {
    const entity = entityFactory.deletePublishers(customerId);
    return entity.post({ PublisherIds: publisherIds });
  },
  getMatchedPublishers(customerId, searchText, searchType) {
    const entity = entityFactory.matchedPublisher(customerId, searchType);
    return entity.post({
      Text: searchText,
    });
  },
  getMatchedApps(customerId, publiserId) {
    const entity = entityFactory.matchedApp(customerId, publiserId);
    return entity.get(null, { query: null }, false);
  },
};
